import {getDataWithPromise, Globals} from "../globals";
import { handleAjaxError } from './ErrorHandlingFunctions'
export const getPupilObservations = ( pupil_uid, school360_school_id, date_from, date_to, params, onComplete ) =>
{
    const isPost = typeof ( params ) === 'object' ;

    const ald_id = isPost ? 0 : params ;
    const postParams = isPost ? params : {} ;
    const postType = isPost ? 'POST' : 'GET' ;

    // Legacy alert - this will perform a POST if it's the new format object params

    const url = Globals.APIFolder + '/eyfsn/school/current/user/' + pupil_uid + '/observations?ald_id=' + ald_id + '&date_from='+date_from+'&date_to='+date_to ;

    getDataWithPromise ( url, postType, postParams, true )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}
